import React, { useMemo, useState } from 'react';
import { Accordion, Button, InlineNotification, Table, Text } from '@ui';
import { translatorFor } from '../shared/i18n';
import { LazyState, RefreshButton } from '../shared/LazySection';
import { humanize } from '../shared/types';
import { IgnoredTypes } from './IgnoredTypes';
import { MappingEditor } from './MappingEditor';
import { catalogFrom } from './mappingDraft';
const t = translatorFor('equipment_mapping');
export function EquipmentMappingCard({ urls, checklist, equipmentTypeMap, ignoredTypes, deviceTypeOptions, deviceSubtypeOptions, onEquipmentTypeMapChange, onIgnoredTypesChange }) {
    const [expanded, setExpanded] = useState(false);
    const [editing, setEditing] = useState(false);
    const [saved, setSaved] = useState(false);
    const catalog = checklist.data ? catalogFrom(checklist.data) : null;
    const toggle = (next) => {
        setExpanded(next);
        if (next)
            checklist.load();
    };
    const rows = useMemo(() => equipmentTypeMap.map((row) => {
        var _a;
        return ({
            id: `${row.ipSystemDeviceType}-${(_a = row.ipSystemDevice) !== null && _a !== void 0 ? _a : ''}-${row.stEquipmentTypeId}`,
            ipType: humanize(row.ipSystemDeviceType),
            ipSubtype: row.ipSystemDevice ? humanize(row.ipSystemDevice) : '',
            stType: row.stEquipmentType
        });
    }), [equipmentTypeMap]);
    const unmappedTypes = useMemo(() => {
        const mapped = new Set(equipmentTypeMap.map((row) => row.ipSystemDeviceType));
        return deviceTypeOptions.filter((kind) => !mapped.has(kind));
    }, [equipmentTypeMap, deviceTypeOptions]);
    const columns = [
        { dataKey: 'ipType', label: t('ip_type_heading'), columnType: 'primary', width: '35%' },
        { dataKey: 'ipSubtype', label: t('ip_subtype_heading'), width: '30%' },
        { dataKey: 'stType', label: t('st_type_heading'), width: '35%' }
    ];
    return (React.createElement(React.Fragment, null,
        unmappedTypes.length > 0 && (React.createElement(InlineNotification, { variant: "warning" }, t('unmapped_warning', { types: unmappedTypes.map(humanize).join(', ') }))),
        React.createElement(Accordion, { variant: "section", title: t('title'), previewContent: t('preview', { count: rows.length }), isExpanded: expanded, onToggle: toggle },
            React.createElement("div", { className: "service-titan-settings__accordion-body" },
                React.createElement(LazyState, { loading: checklist.loading, error: checklist.error, onRetry: () => {
                        checklist.reload();
                    } }),
                saved && !editing && React.createElement(InlineNotification, { variant: "success" }, t('saved')),
                editing ? (React.createElement(MappingEditor, { urls: urls, catalog: catalog, catalogUnavailable: checklist.data !== null && catalog === null, equipmentTypeMap: equipmentTypeMap, deviceTypeOptions: deviceTypeOptions, deviceSubtypeOptions: deviceSubtypeOptions, onCancel: () => setEditing(false), onSaved: (savedRows) => {
                        onEquipmentTypeMapChange(savedRows);
                        setSaved(true);
                        setEditing(false);
                    } })) : (React.createElement(React.Fragment, null,
                    React.createElement(Table, { data: rows, columns: columns, getItemId: (row) => row.id, emptyContent: React.createElement(Text, { variant: "body" }, t('empty')), variant: "listing" }),
                    React.createElement("div", { className: "service-titan-settings__actions" },
                        React.createElement(Button, { variant: "secondary", onClick: () => {
                                setSaved(false);
                                setEditing(true);
                            } }, t('edit')),
                        checklist.data && (React.createElement(RefreshButton, { disabled: checklist.loading, onRefresh: () => {
                                checklist.reload();
                            } }))))),
                React.createElement(IgnoredTypes, { urls: urls, ignoredTypes: ignoredTypes, onChange: onIgnoredTypesChange })))));
}
export default EquipmentMappingCard;
